import { Component, computed, input } from '@angular/core';
import { InnogyComponentRendering } from '@core/jss-models';
import {
  TextField,
  type ComponentRendering,
  type LinkField,
  type RichTextField,
} from '@core/jss-proxy';
import {
  computedContentSectionId,
  computedContentSectionTheme,
  ContentSectionComponent,
} from '@core/content-section';
import { ContactSectionComponent, type ContactItem } from '@content/ui/contact';
import {
  getField,
  getItemLinkFieldValue,
  getTreelistEntries,
  normalizeLinkField,
} from '@core/jss-utils';

interface ContactSectionComponentRendering extends InnogyComponentRendering {
  title: TextField;
  introduction: TextField;
}

@Component({
  selector: 'wl-contact-section-container',
  standalone: true,
  templateUrl: './contact-section-container.component.html',
  imports: [ContentSectionComponent, ContactSectionComponent],
})
export class ContactSectionContainerComponent {
  readonly rendering = input.required<ContactSectionComponentRendering>();

  readonly id = computedContentSectionId(this.rendering);
  readonly theme = computedContentSectionTheme(this.rendering);

  readonly fields = computed(() => this.rendering().fields);

  readonly uid = computed(() => this.rendering().uid);
  readonly title = computed(() => getField<TextField>(this.fields(), 'title'));
  readonly introduction = computed(() =>
    getField<TextField>(this.fields(), 'introduction')
  );
  readonly contactItems = computed(() => {
    return getTreelistEntries(this.fields(), 'contactItems', []).map(
      (contactItem) => this.#getContactItem(contactItem)
    );
  });

  #getContactItem(rendering: ComponentRendering): ContactItem {
    return {
      icon: getItemLinkFieldValue(rendering.fields, 'icon'),
      title: getField<TextField>(rendering.fields, 'title'),
      description: getField<RichTextField>(rendering.fields, 'description'),
      chatButton: getField<TextField>(rendering.fields, 'chatButton'),
      alternativeButton: normalizeLinkField(
        getField<LinkField>(rendering.fields, 'alternativeButton')
      ),
    };
  }
}
